import { useState, useEffect, useRef } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
import { Tooltip } from "primereact/tooltip";
// import { Toast } from "primereact/toast";
import { toast } from "react-toastify";

import "./completeRecommendation.css";
import Table from "../../table/table";
import { postRequest } from "../../../actions/Handler";

export default function CompleteRecommendation({
  showPopup,
  updatePrimaryModalState,
  popupName,
  eventReportId,
  onExit,
  eventTitle,
  setReloadCardVal,
}: any) {
  const [from, fromChange] = useState();
  const [dateMessage, setDateMessage] = useState("");
  // const toast = useRef<Toast>(null);
  const [saveLoader, setSaveLoader] = useState(false);

  const columns = [
    {
      header: "#",
      body: (rowData: any, column: any) => (
        <>
          <span>{column.rowIndex + 1}</span>
        </>
      ),
      sortable: false,
      filter: false,
    },
    {
      header: "Recommendation",
      field: "recommendationText",
      sortable: false,
      filter: false,
      body: (rowData: any) => (
        <>
          <Tooltip target=".recommendation"></Tooltip>
          <span
            className="recommendation"
            data-pr-position="bottom"
            data-pr-tooltip={rowData.recommendationText}
          >
            {rowData.recommendationText.length > 50
              ? rowData.recommendationText.slice(0, 49) + "..."
              : rowData.recommendationText}
          </span>
        </>
      ),
    },
  ];

  const mess = () => {
    toast("Recommendation completed successfully", {
      type: "success",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };
  const errormess = () => {
    toast("Something went wrong!", {
      type: "error",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };

  const GetMaxDate = () => {
    var dt = new Date();
    // dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
    // var offset = -240; //Timezone offset for EST in minutes.
    // var estDate = new Date(dt.getTime() + offset * 60 * 1000);
    return dt;
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (!from) {
      setDateMessage("Recommendations Completed Date is required");
    } else {
      var eventDate = new Date(from);
      var currentDateTime= new Date();
      eventDate.setTime(currentDateTime.getTime())
      const utcDate = eventDate.toISOString();

      setSaveLoader(true);
      setDateMessage("");
      postRequest({
        url: "api/EventReportReview/CompleteRecommendation",
        data: {
          eventReportId: eventReportId,
          reviewType: popupName === "Primary Review" ? 1 : 2,
          recommendationCompletedOn: utcDate,
        },
      }).then((res) => {
        mess();
        // setTimeout(() => {
        setSaveLoader(false);
        reset();
        updatePrimaryModalState();
        // }, 1000);
        onExit();
        setReloadCardVal();
      })
      .catch(
        (e:any) =>{
          console.log(e);
          errormess();
          setSaveLoader(false);
        }
      )
    }
  };
  const reset = () => {
    setDateMessage("");
    fromChange(undefined);
  };
  if (showPopup) {
    return (
      <>
        {saveLoader ? (
          <>
            <div id="q11">
              <div className="loading">
                <div className="obj"></div>
              </div>
            </div>{" "}
          </>
        ) : null}
        {/* <Toast ref={toast}></Toast> */}
        <Modal
          show={showPopup}
          onHide={() => {
            reset();
            updatePrimaryModalState();
          }}
          backdrop="static"
          size="sm"
          dialogClassName="modal-200w"
          className="popupClass"
          keyboard={false}
          enforceFocus={true}
          scrollable={true}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                color: "#495057",
                fontSize: "15px",
                fontWeight: "600",
              }}
            >
              Recommendations Review
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Container fluid={true} className="d-flex flex-row"> */}
            <Row className="mb-1" md="6" sm="12" xs="12">
              <Col xs="12" sm="12" md="4">
                <span className="titleText">{popupName}:</span>
              </Col>
              <Col className="reclabel" xs="12" sm="12" md="6">
                {eventTitle}
              </Col>
            </Row>
            {/* </Container> */}
            {/* <Container fluid={true} className="d-flex flex-row mt-2"> */}
            <Row className="mb-1 reclabel" md="4" sm="12" xs="12">
              <Col xs="3" sm="3" md="4">
                <span className="titleText">Recommendation:</span>
              </Col>
              <Col className="subreclabel" xs="12" sm="12" md="6">
                <div className="mb-3">
                  <Table
                    column={columns}
                    lazy={false}
                    screen="completeRecommendation"
                    pagination={false}
                    eventReportId={eventReportId}
                    popupName={popupName}
                  ></Table>
                </div>
              </Col>
            </Row>
            {/* </Container> */}
            {/* <Container fluid={true} className="d-flex flex-row mt-2"> */}
            <Row className="mb-1 rec" md="4" sm="12" xs="12">
              <Col className="reclabel" xs="12" sm="3" md="4">
                <span className="titleText">
                  Recommendations Completed:
                  <span style={{ color: "red" }}>*</span>
                </span>
              </Col>
              <Col className="subreclabel" xs="12" sm="12" md="4">
                <Calendar
                  readOnlyInput
                  style={{ width: "100%" }}
                  name="eventDate"
                  value={from}
                  onChange={(date: any) => {
                    fromChange(date.value);
                    if (date.value === null) {
                      setDateMessage(
                        "Recommendations Completed Date is required"
                      );
                    } else {
                      setDateMessage("");
                    }
                  }}
                  className="calender-custom"
                  viewDate={GetMaxDate()}
                  maxDate={GetMaxDate()}
                  showIcon
                  dateFormat="mm/dd/yy"
                />
                <p className="err-text">{dateMessage}</p>
              </Col>
            </Row>
            {/* </Container> */}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="buttonCss"
              onClick={() => {
                reset();
                updatePrimaryModalState();
              }}
            >
              Cancel
            </button>
            <button className="buttonCss" onClick={(e) => onSubmit(e)}>
              Save
            </button>
          </Modal.Footer>
        </Modal>
      </>
      // <Modal
      //   show={showPopup}
      //   onHide={() => {
      //     reset();
      //     updatePrimaryModalState();
      //   }}
      //   backdrop="static"
      //   size="sm"
      //   dialogClassName="modal-200w"
      //   className="popupClass"
      //   keyboard={false}
      //   enforceFocus={true}
      //   scrollable={true}
      //   centered
      // >
      //   <Modal.Header closeButton>
      //     <Modal.Title
      //       style={{
      //         color: "#495057",
      //         fontSize: "15px",
      //         fontWeight: "600",
      //       }}
      //     >
      //       Recommendations Review
      //     </Modal.Title>
      //   </Modal.Header>
      //   <Modal.Body>
      //     {/* <Container fluid={true} className="d-flex flex-row"> */}
      //     <Row className="mb-1" md="6" sm="12" xs="12">
      //       <Col xs="12" sm="12" md="4">
      //         <span className="titleText">{popupName}:</span>
      //       </Col>
      //       <Col className="reclabel" xs="9" sm="9" md="6">
      //         At site: INOVA Alexandria Hospital, on 11/18/2021, patient 45
      //         Years-old, Male, with Difficult ventilation issue.
      //       </Col>
      //     </Row>
      //     {/* </Container> */}
      //     {/* <Container fluid={true} className="d-flex flex-row mt-2"> */}
      //     <Row className="mb-1 reclabel" md="4" sm="12" xs="12">
      //       <Col xs="3" sm="3" md="4">
      //         <span className="titleText">Recommendation:</span>
      //       </Col>
      //       <Col className="subreclabel" xs="12" sm="12" md="6">
      //         <div className="mb-3">
      //           <Table
      //             column={columns}
      //             lazy={false}
      //             screen="completeRecommendation"
      //             pagination={false}
      //             eventReportId={eventReportId}
      //             popupName={popupName}
      //           ></Table>
      //         </div>
      //       </Col>
      //     </Row>
      //     {/* </Container> */}
      //     {/* <Container fluid={true} className="d-flex flex-row mt-2"> */}
      //     <Row className="mb-1 rec" md="4" sm="6" xs="6">
      //       <Col className="reclabel" xs="12" sm="3" md="4">
      //         <span className="titleText">
      //           Recommendations Completed:
      //           <span style={{ color: "red" }}>*</span>
      //         </span>
      //       </Col>
      //       <Col className="subreclabel" xs="9" sm="9" md="4">
      //         <Calendar
      //           style={{ width: "100%" }}
      //           name="eventDate"
      //           value={from}
      //           onChange={(date: any) => {
      //             fromChange(date.value);
      //             if (date.value === null) {
      //               setDateMessage(
      //                 "Recommendations Completed Date is required"
      //               );
      //             } else {
      //               setDateMessage("");
      //             }
      //           }}
      //           className="calender-custom"
      //           maxDate={new Date()}
      //           showIcon
      //           dateFormat="mm/dd/yy"
      //         />
      //         <p className="err-text">{dateMessage}</p>
      //       </Col>
      //     </Row>
      //     {/* </Container> */}
      //   </Modal.Body>
      //   <Modal.Footer>
      //     <button
      //       className="buttonCss"
      //       onClick={() => {
      //         reset();
      //         updatePrimaryModalState();
      //       }}
      //     >
      //       Cancel
      //     </button>
      //     <button className="buttonCss" onClick={(e) => onSubmit(e)}>
      //       Save
      //     </button>
      //   </Modal.Footer>
      // </Modal>
    );
  } else {
    return <></>;
  }
}
